import { BaseControl, ControlPosition } from "./BaseControl.js";
import { Pano } from "../Pano.js";
import { Resource } from "../../model/Resource.js";
import { Language } from "../../model/Language.js";

export class ControlOpen extends BaseControl {

    constructor(pano: Pano) {
        super(pano);

        this.pano.addButton(
            {
                icon: "fal fa-arrow-up-right-from-square",
                position: ControlPosition.RIGHT,
                tooltip: Language.resolve("Im Frontend öffnen", "Open in frontend"),
                onInit: (item) => {
                },
                onClick: (item) => {
                    if (this.pano.current)
                        window.open(Resource.SITE + "#video/" + this.pano.current.id, "_pano");
                }
            }
        );
    }
}